import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  Button,
  TextField,
  Alert,
  CircularProgress
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Colors } from "../utils/colors";
import { API } from "../constant/apiConstant";

export default function AdminForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    show: false,
    type: "info",
    message: ""
  });

  const showAlert = (type, message, time = 5000) => {
    setAlert({
      show: true,
      type,
      message
    });

    setTimeout(() => {
      setAlert((prev) => ({ ...prev, show: false }));
    }, time);
  };

  const sendResetOTP = async () => {
    setLoading(true);

    try {
      const res = await fetch(`${API.BASE_URL}/api/admin/auth/forgot-password/send-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email })
      });

      const data = await res.json();

      if (!data.status) {
        showAlert("error", data.message || "Unable to send reset OTP");
        setLoading(false);
        return;
      }

      showAlert("success", "Password reset OTP sent to your admin email");

      setTimeout(() => {
        navigate("/verify-reset-otp", { state: { email } });
      }, 1500);
    } catch (error) {
      showAlert("error", "Unable to connect to server");
    }

    setLoading(false);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: Colors.secondary,
        p: 2
      }}
    >
      <Card sx={{ p: 4, width: "100%", maxWidth: 520, borderRadius: 2 }}>
        <Typography variant="h5" fontWeight={700} sx={{ color: Colors.accent }}>
          Forgot Password
        </Typography>

        {alert.show && (
          <Alert severity={alert.type} sx={{ mt: 2 }}>
            {alert.message}
          </Alert>
        )}

        <TextField
          label="Admin Email"
          fullWidth
          sx={{ mt: 2 }}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 3, backgroundColor: Colors.secondary, color: "white" }}
          onClick={sendResetOTP}
          disabled={!email || loading}
        >
          {loading ? <CircularProgress size={22} sx={{ color: "white" }} /> : "Send Reset OTP"}
        </Button>

        <Typography
          sx={{
            mt: 2,
            textAlign: "center",
            color: Colors.accent,
            fontSize: 14,
            cursor: "pointer",
            fontWeight: 600
          }}
          onClick={() => navigate("/")}
        >
          Back to Login
        </Typography>
      </Card>
    </Box>
  );
}
